import * as React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface SelectOptionWithDescriptionProps {
  value: string;
  name: string;
  description?: string;
  disabled?: boolean;
  className?: string;
}

/**
 * Built on the Radix primitive rather than ui/select's SelectItem because that
 * one puts every child inside ItemText, and Radix clones ItemText's children
 * into the closed trigger — the description would land there too.
 */
const SelectOptionWithDescription: React.FC<SelectOptionWithDescriptionProps> = ({
  value,
  name,
  description,
  disabled,
  className,
}) => (
  <SelectPrimitive.Item
    value={value}
    disabled={disabled}
    textValue={name}
    className={cn(
      'relative flex w-full cursor-pointer select-none flex-col items-start rounded-sm py-2 pl-2 pr-8 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
      className,
    )}
  >
    <span className="absolute right-2 top-2.5 flex h-3.5 w-3.5 items-center justify-center">
      <SelectPrimitive.ItemIndicator>
        <Check className="h-4 w-4" />
      </SelectPrimitive.ItemIndicator>
    </span>
    <SelectPrimitive.ItemText className="revy-cjk font-medium leading-[1.5]">
      {name}
    </SelectPrimitive.ItemText>
    {description && (
      <span className="revy-cjk mt-0.5 max-w-[36em] text-xs leading-[1.6] tracking-[0.02em] text-muted-foreground">
        {description}
      </span>
    )}
  </SelectPrimitive.Item>
);

export { SelectOptionWithDescription };
